<div class="layout-menu-profile">
    <button class="p-link" (click)="toggleMenu()" pTooltip="Toggle Menu" [tooltipDisabled]="isTooltipDisabled">
      <div class="profile-avatar bg-primary flex align-items-center justify-content-center border-circle w-3rem h-3rem text-white text-xl font-semibold">
        {{ getFirstLetter(profile.displayName || '') }}
      </div>

        <span>
            <strong>{{profile.displayName ? profile.displayName : 'Loading...'}}</strong>
        </span>
        <i class="layout-menu-profile-toggler pi pi-fw"
           [ngClass]="{'pi-angle-down': menuProfilePosition === 'start' || isHorizontal, 'pi-angle-up': menuProfilePosition === 'end' && !isHorizontal}"></i>
    </button>

    <ul *ngIf="menuProfileActive" [@menu]="isHorizontal ? 'overlay' : 'inline'">
        @if(profileDetails.roleEnum === AdminRoles.SuperAdmin){
            <li pTooltip="Users" [tooltipDisabled]="isTooltipDisabled">
                <button class="p-link" (click)="redirectUserPage()">
                    <i class="pi pi-user pi-fw"></i>
                    <span>Users</span>
                </button>
            </li>
        }
        <li pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled">
            <button class="p-link" (click)="showProfileDialog()">
                <i class="pi pi-file-o pi-fw"></i>
                <span>Profile</span>
            </button>
        </li>
        <li pTooltip="Logout" [tooltipDisabled]="isTooltipDisabled">
            <button class="p-link" (click)="_authService.signOut()">
                <i class="pi pi-power-off pi-fw"></i>
                <span>Logout</span>
            </button>
        </li>
    </ul>
</div>
